/**
 * 権限セットIDを保持するVO
 *
 */
export class AuthoritySetIDModel {
  public authoritySetId: string = <string>'';

  public authoritySetName: string = <string>'';

  public adminDiv: string = <string>'';

  public authorityStatus: string = <string>'';
}
